import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { INPUT_SIZE } from "../../../common/ThemeConstants";
import BasicModalFormComponent from "../../../components/formComponent/BasicModalFormComponent";
import FormTextField from "../../../components/general/FormTextField";
import {
  deleteRow,
  resetState,
  setFormFieldValue,
  setInitialState,
  setSearchFieldValue,
  submitForm
} from "../../../redux/actions/basicFormAction";
import { UPDATE_FORM_FIELD } from "../../../redux/reduxConstants";

const initialFormValues = {
  VendorId: null,
  VendorName: "",
  Address: "",
  ContactNumber: "",
  Email: "",
  PocDetail: []
};

const initialSearchValues = {
  VendorId: null,
  VendorName: "",
  Address: "",
  ContactNumber: "",
  Email: "",
  PocDetail: []
};
const columns = [
  {
    title: "Vendor Name",
    dataIndex: "VendorName",
    key: "VendorName"
  },
  {
    title: "Address",
    dataIndex: "Address",
    key: "Address"
  },
  {
    title: "Contact Number",
    dataIndex: "ContactNumber",
    key: "ContactNumber"
  },
  {
    title: "Email",
    dataIndex: "Email",
    key: "Email"
  }
];

const Vendor = () => {
  const dispatch = useDispatch();
  const controller = new window.AbortController();
  const userData = useSelector((state) => state.authReducer);

  const [updateId, setUpdateId] = useState(null);
  const [shouldCloseModal, setShouldCloseModal] = useState(false);

  const {
    formFields,
    searchFields,
    itemList,
    formLoading,
    tableLoading
  } = useSelector((state) => state.basicFormReducer);

  useEffect(() => {
    dispatch(
      setInitialState(
        "/CrudVendor",
        initialFormValues,
        initialFormValues,
        initialSearchValues,
        controller,
        userData
      )
    );

    return () => {
      controller.abort();
      dispatch(resetState());
    };
  }, []);

  useEffect(() => {
    if (updateId === null) return;
    const selectedItem = itemList.find((item) => item.VendorId === updateId);
    if (selectedItem) {
      dispatch({
        type: UPDATE_FORM_FIELD,
        payload: selectedItem
      });
    }
    setUpdateId(null);
  }, [updateId, itemList]);

  const handleSearchChange = (data) => {
    dispatch(setSearchFieldValue(data));
  };

  const handleFormChange = (data) => {
    dispatch(setFormFieldValue(data));
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    const trimmedSearch = {
      ...searchFields,
      VendorName: searchFields.VendorName?.trim() || ""
    };
    dispatch(
      setInitialState(
        "/CrudVendor",
        trimmedSearch,
        initialFormValues,
        trimmedSearch,
        controller,
        userData
      )
    );
  };

  const handleDeleteRow = (id) => {
    dispatch(
      deleteRow(
        "/CrudVendor",
        { ...formFields, VendorId: id },
        controller,
        userData
      )
    );
  };

  const handleFormSubmit = (e, id) => {
    e.preventDefault();
    dispatch(
      submitForm(
        "/CrudVendor",
        { ...formFields, PocDetail: [] },
        initialFormValues,
        controller,
        userData,
        id,
        () => setShouldCloseModal(true)
      )
    );
  };

  const searchPanel = (
    <Fragment>
      <FormTextField
        colSpan={4}
        label="Vendor Name"
        name="VendorName"
        size={INPUT_SIZE}
        value={searchFields.VendorName}
        onChange={handleSearchChange}
      />
      <FormTextField
        colSpan={4}
        label="Contact Number"
        name="ContactNumber"
        size={INPUT_SIZE}
        value={searchFields.ContactNumber}
        onChange={handleSearchChange}
        isNumber="true"
        maxLength={11}
      />
      <FormTextField
        colSpan={4}
        label="Email"
        name="Email"
        size={INPUT_SIZE}
        value={searchFields.Email}
        onChange={handleSearchChange}
      />
    </Fragment>
  );

  const handleFormClose = () => {
    setUpdateId(null);
    setShouldCloseModal(false);
  };

  const handleReset = () => {
    dispatch(
      setInitialState(
        "/CrudVendor",
        initialSearchValues,
        initialFormValues,
        initialSearchValues,
        controller,
        userData
      )
    );
  };

  const formPanel = (
    <Fragment>
      <FormTextField
        colSpan={8}
        label="Vendor Name"
        name="VendorName"
        size={INPUT_SIZE}
        value={formFields.VendorName}
        onChange={handleFormChange}
        required={true}
      />
      <FormTextField
        colSpan={8}
        label="Address"
        name="Address"
        size={INPUT_SIZE}
        value={formFields.Address}
        onChange={handleFormChange}
        required={true}
      />
      <FormTextField
        colSpan={8}
        label="Contact Number"
        name="ContactNumber"
        size={INPUT_SIZE}
        value={formFields.ContactNumber}
        onChange={handleFormChange}
        required={true}
        maxLength={11}
        isNumber="true"
        minLength={11}
        pattern={".{7,11}"}
      />
      <FormTextField
        colSpan={8}
        label="Email"
        name="Email"
        size={INPUT_SIZE}
        value={formFields.Email}
        onChange={handleFormChange}
        required={true}
        type="email"
      />
    </Fragment>
  );

  return (
    <BasicModalFormComponent
      formTitle="Vendor"
      searchPanel={searchPanel}
      formPanel={formPanel}
      searchSubmit={handleSearchSubmit}
      onFormSave={handleFormSubmit}
      onFormClose={handleFormClose}
      tableRows={itemList}
      tableLoading={tableLoading}
      formLoading={formLoading}
      tableColumn={columns}
      deleteRow={handleDeleteRow}
      actionID="VendorId"
      editRow={setUpdateId}
      fields={initialFormValues}
      reset={false}
      handleReset={handleReset}
      crudTitle="Vendor"
      externalCloseTrigger={shouldCloseModal}
    />
  );
};

export default Vendor;
